// Move the single listbox tab stop without changing the selected value.
export function moveDropdownFocus(targets, currentIndex, key) {
  if (!targets.length) return -1;

  let index = Math.max(0, Math.min(currentIndex, targets.length - 1));
  if (key === 'ArrowDown') index = (index + 1) % targets.length;
  else if (key === 'ArrowUp') index = (index - 1 + targets.length) % targets.length;
  else if (key === 'Home') index = 0;
  else if (key === 'End') index = targets.length - 1;
  else if (key !== undefined) return currentIndex;

  targets[index].focus();
  return index;
}
